// In your Hooks/Courses/useCourseList.js or similar file
import { useState, useEffect } from 'react';
import { selfLearnerService } from 'PlatForms/SelfLMS/Services/Courses/CourseService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// In useCourses.js
const useCourses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [enrollingId, setEnrollingId] = useState(null);
  
  
  // Pagination state
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 9,
    totalCount: 0,
    totalPages: 0,
    orderByLatest: true
  });

  // In useCourses.js, update the fetchCourses function
const fetchCourses = async (pageNumber = 1, pageSize = 9, orderByLatest = true) => {
  try {
    setLoading(true);
    setError(null);
    
    const data = await selfLearnerService.getAvailableCourses({
      PageNumber: pageNumber,
      PageSize: pageSize,
      OrderByLatest: orderByLatest,
      isPublished: true,
      // Add filter to get only non-enrolled courses
      excludeEnrolled: true  // Add this parameter if your API supports it
    });
    
    console.log("available courses Response:", data);
    
    // Don't filter here - server should handle it
    setCourses(data.items || data || []);
    
    // Update pagination with server values
    setPagination({
      currentPage: Number(data.pageNumber) || pageNumber,
      pageSize: Number(data.pageSize) || pageSize,
      totalCount: Number(data.totalCount) || 0,
      totalPages: Number(data.totalPages) || 
                 Math.ceil((Number(data.totalCount) || 0) / (Number(data.pageSize) || pageSize)),
      orderByLatest: data.orderByLatest !== undefined ? data.orderByLatest : orderByLatest
    });
    
  } catch (err) {
    console.error("Error fetching courses:", err);
    setError(err.response?.data?.message || err.message || 'Failed to fetch courses');
    setCourses([]);
    toast.error(err.response?.data?.message || err.message || 'Failed to fetch courses');
  } finally {
    setLoading(false);
  }
};

  const enrollInCourse = async (courseId) => {
    try {
      setEnrollingId(courseId);
      const enrollmentResponse = await selfLearnerService.enrollInCourse(courseId);
      
      console.log("Enrollment response:", enrollmentResponse);

      // Update course with enrollment status
      setCourses(prevCourses =>
        prevCourses.map(course =>
          course.id === courseId ? { 
            ...course, 
            isEnrolled: true,
            enrollmentId: enrollmentResponse.enrollmentId || enrollmentResponse.id 
          } : course
        )
      );

      return enrollmentResponse;
    } catch (error) {
      throw error;
    } finally {
      setEnrollingId(null);
    }
  };

  // Handle page change
  const handlePageChange = (pageNumber) => {
    fetchCourses(pageNumber, pagination.pageSize, pagination.orderByLatest);
  };

  // Handle page size change
  const handlePageSizeChange = (pageSize) => {
    fetchCourses(1, pageSize, pagination.orderByLatest);
  };

  // Handle sort change
  const handleSortChange = (orderByLatest) => {
    fetchCourses(1, pagination.pageSize, orderByLatest);
  };

  // Refresh courses
  const refetch = () => fetchCourses(pagination.currentPage, pagination.pageSize, pagination.orderByLatest);

  // Initial fetch
  useEffect(() => {
    fetchCourses(1, 9, true);
  }, []);

  return {
    courses,
    loading,
    error,
    enrollingId,
    pagination,
    enrollInCourse,
    refetch,
    handlePageChange,
    handlePageSizeChange,
    handleSortChange,
    fetchCourses // expose fetch function for manual calls
  };
};

export default useCourses;
